import { render, staticRenderFns } from "./JjForm.vue?vue&type=template&id=2dda112d&scoped=true"
import script from "./JjForm.vue?vue&type=script&lang=js"
export * from "./JjForm.vue?vue&type=script&lang=js"
import style0 from "./JjForm.vue?vue&type=style&index=0&id=2dda112d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda112d",
  null
  
)

export default component.exports